export const EVENT_CATEGORIES = {
    INSTALLATION: 'installation',
    ALERTS: 'alerts',
    GLOBAL_MENU: 'global_menu',
    NOTIFICATIONS: 'notifications',
    CONTROLS_MANAGEMENT: 'controls_management',
    BOX_LINKING: 'box_linking',
    INTERVENTION: 'intervention',
    INTERVENTION_HISTORY: 'intervention_history',
    ALERT_EMAILING_FREQUENCY: 'alert_emailing_frequency',
    ALERT_EMAILING_STATUS: 'alert_emailing_status',
    LINK_REQUEST: 'link_request',
    VISIO_ASSISTANCE: 'visio_assistance',
    SITE_MAP: 'site_map',
    DATA_SHARING: 'data_sharing',
} as const;

export const EVENT_INSTALLATION = {
    CUSTOMER_DETAILS: 'customer_details_viewed',
    BOX_DETAILS: 'box_details_viewed',
    EVENTS_HISTORY: 'events_history_viewed',
    BOX_SEARCHED: 'box_searched',
    BOX_LIST_CLICK: 'box_list_click',
    INSTALLATION_TAB_CLICK: 'installation_tab_click',
    DEVICE_LIST_CLICK: 'device_list_click',
    MANUAL_REFRESH_CLICK: 'manual_refresh_click',
} as const;

export const EVENT_ALERTS = {
    ALERTS_MENU_CLICK: 'alerts_menu_click',
    ALERT_CONFIGURATION_CLICK: 'alert_configuration_click',
    ALERT_MANAGED: 'alert_managed',
    ALERT_SEARCHED: 'alert_searched',
    ALERT_DELETED: 'alert_deleted',
    ALERT_DETAIL_CLICK: 'alert_detail_click',
    ALERT_RESOLUTION_STARTED: 'alert_resolution_started',
    ALERT_CONTACT_SUPPORT_REQUESTED: 'alert_contact_support_requested',
    ALERT_DETAIL_COMPLETED: 'alert_detail_completed',
} as const;

export const EVENT_GLOBAL_MENU = {
    GLOBAL_MENU_CLICK: 'global_menu_click',
    DOCUMENT_CLICK: 'document_click',
    LANGUAGE_MODIFIED_CLICK: 'language_modified_click',
} as const;

export const EVENT_NOTIFICATIONS = {
    MENU_NOTIFICATIONS_VIEWED: 'menu_notifications_viewed',
    LINK_REQUEST_RESENT_FROM_NOTIFICATION: 'link_request_resent_from_notification',
    REMOTE_SERVICE_REQUEST_RESENT_FROM_NOTIFICATION: 'remote_service_request_resent_from_notification',
    ALERTS_LIST_ACCESS_FROM_NOTIFICATION: 'alerts_list_access_from_notification',
    MESSAGE_DETAIL_FROM_NOTIFICATION: 'message_detail_from_notification',
} as const;

export const EVENT_SITE_MAP = {
    MAP_VIEW_CLICKED: 'map_view_clicked',
    SITE_VIEWED_FROM_MAP_LIST: 'site_viewed_from_map_list',
} as const;

export const EVENT_DATA_SHARING = {
    DATA_SHARED: 'data_shared',
} as const;

export const EVENT_CONTROLS_MANAGEMENT = {
    ADD_REMOTE_CONTROL: 'add_remote_control',
} as const;

export const EVENT_BOX_LINKING = {
    BOX_LINKING_REQUESTED: 'box_linking_requested',
    BOX_SERVICE_REQUESTED: 'box_service_requested',
    BOX_DELETED: 'box_deleted',
} as const;

export const EVENT_INTERVENTION = {
    REMOTE_SERVICE_REQUESTED: 'remote_service_requested',
    PARAMETER_MODIFIED: 'parameter_modified',
    REMOTE_SERVICE_ACCEPTED: 'remote_service_accepted',
    REMOTE_BOX_REBOOT: 'remote_box_reboot',
    REMOTE_SERVICE_LINK_CLICKED: 'remote_service_link_clicked',
    INTERVENTION_REQUEST_ENDED: 'intervention_request_ended',
} as const;

export const EVENT_INTERVENTION_HISTORY = {
    VIEW_REPORT_CLICK: 'view_report_click',
    EMAIL_REPORT_SENT: 'email_report_sent',
} as const;

export const EVENT_LINK_REQUEST = {
    LINK_REQUEST_LINK_CLICKED: 'link_request_link_clicked',
    LINK_REQUEST_LOGGED_IN: 'link_request_logged_in',
    LINK_REQUEST_ACCEPTED: 'link_request_accepted',
} as const;

export const EVENT_VISIO_ASSISTANCE = {
    VIDEO_CALL_INVITATION_SENT: 'video_call_invitation_sent',
    VIDEO_CALL_JOINED: 'video_call_joined',
    VIDEO_CALL_STOPPED_AND_JOINED: 'video_call_stopped_and_joined',
} as const;
